// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueMaterial from 'vue-material'
import VueRouter from 'vue-router'
import Login from './components/Login.vue'
import Dashboard from './components/Dashboard.vue'
import Carico from './components/Carico.vue'
import Scarico from './components/Scarico.vue'
import ScaricoNuovo from './components/ScaricoNuovo.vue'
import ScaricoEdit from './components/ScaricoEdit.vue'
import CaricoEdit from './components/CaricoEdit.vue'
import CaricoUpload from './components/CaricoUpload.vue'
import Depots from './components/Depots.vue'
import ViewBarcode from './components/ViewBarcode.vue'
import VueMaterialLocales from '@undecaf/vue-material-locales'
import axios from 'axios'
import it from '@undecaf/vue-material-locales/dist/locale/it'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import VueSimpleAlert from 'vue-simple-alert'
import VueCookie from 'vue-cookie'
import MdVuelidated from '@undecaf/vue-material-vuelidate'
import '@undecaf/vue-material-vuelidate/dist/components.css'
import VueNumeric from 'vue-numeric'
import moment from 'moment'
import numeral from 'numeral'
import Swal from 'sweetalert2'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import JsonCSV from 'vue-json-csv'
import MdModalDialog from 'vue-material-modal-dialog'
//import 'vue-material-modal-dialog/dist/md-modal-dialog.css'

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(VueMaterial)
Vue.use(VueMaterialLocales, [it])
Vue.use(VueSimpleAlert)
Vue.use(VueCookie)
Vue.use(MdVuelidated)
Vue.use(VueNumeric)
Vue.use(Loading,{
  color: '#448aff',
  width: 128,
  height: 128
});
Vue.use(MdModalDialog)
Vue.component('downloadCsv', JsonCSV)

Vue.prototype.$http = axios

const routes = [
  { path: '/login', component: Login, meta: { requiresAuth: false } },
  { path: '/dashboard', component: Dashboard, meta: { requiresAuth: true } },
  { path: '/carico', component: Carico, meta: { requiresAuth: true } },
  { path: '/carico/upload', component: CaricoUpload, meta: { requiresAuth: true } },
  { path: '/carico/nuovo', component: CaricoEdit, meta: { requiresAuth: true } },
  { path: '/carico/edit/:id', component: CaricoEdit, meta: { requiresAuth: true } },
  { path: '/scarico', component: Scarico, meta: { requiresAuth: true } },
  { path: '/scarico/nuovo', component: ScaricoNuovo, meta: { requiresAuth: true } },
  { path: '/scarico/edit/:id', component: ScaricoEdit, meta: { requiresAuth: true } },
  { path: '/magazzini', component: Depots, meta: { requiresAuth: true } },
  { name: 'ViewBarcodes', path: '/scarico/barcode/:id', component: ViewBarcode, meta: { requiresAuth: true } }
]

Vue.mixin({
  methods: {
    showError: function(options) {
      Swal.fire(options)
    }
  }
})

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('user') == null) {
      if (to.path !== '/login') {
        next({
          path: '/login',
          params: { nextUrl: to.fullPath }
        })
      }
    } else next()
  } else {
    if (to.path === '/') {
      next({
        path: '/dashboard'
      })
    } else next()
  }
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
})

Vue.filter("formatAmount", function (value) {
    return numeral(value).format("0.00");
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
    // , Sidebar
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js